// LoaderWrapper.jsx
import React, { useEffect, useState } from "react";

const LoaderWrapper = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      requestAnimationFrame(() => {
        setIsReady(true); // Delay rendering until next frame
      });
    }, 300); // Delay long enough for critical CSS/images

    return () => clearTimeout(timeout);
  }, []);

  if (!isReady) {
    return (
      <div className="loader-container">
        <img src="/BBTloader.gif" alt="Loading..." className="loader-gif" />
      </div>
    );
  }

  return children;
};

export default LoaderWrapper;
